import { InjectionToken } from '@angular/core'

export const GROUP_MANAGEMENT_CONFIG = new InjectionToken<boolean>(
    'GROUP_MANAGEMENT_CONFIG'
)

export const DATA_TOKEN = new InjectionToken<string>('portal-data')
